// Yvonne
// Generated using https://github.com/0J3/preact-typescript

import './style/index.scss';
import App from './components/app';

export default App;
